import type { Resource } from '../../';
export const product_sizeChart_category_infants: Resource = {"default":"Infants"};
